import { render, staticRenderFns } from "./BLRestaurantsLangsWegLayer.vue?vue&type=template&id=67467038"
import script from "./BLRestaurantsLangsWegLayer.vue?vue&type=script&lang=js"
export * from "./BLRestaurantsLangsWegLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports